<template>
  <div class="outer-containers">
    <div class="order-status-container">
      <div class="light"
           v-if="detailStatus == 0"
           style="color: #fff; font-weight: 700; font-size: 19px">
        待支付
      </div>
      <div class="light"
           v-else-if="detailStatus == 1"
           style="color: #fff; font-weight: 700; font-size: 19px">
        已支付
      </div>
      <div class="light"
           v-else-if="detailStatus == 2"
           style="color: #444; font-weight: 700; font-size: 19px">
        已取消
      </div>
      <div class="tips-info"
           v-if="detailStatus == 2">
        由于超时未支付，订单已自动取消，请重新预订
      </div>
      <!---->
    </div>
    <!-- <van-divider /> -->
    <div class="ticket-info">
      <div class="ticket-name">{{ ordersItem.activityName }}</div>
      <div class="flex-start">
        <div class="h3-title-style">法会日期</div>
        <div class="h3-content-style">{{ordersItem.createTime}}</div>
      </div>
      <div class="flex-start"
           style="margintop: 8px; align-items: center">
        <div class="h3-title-style">付款金额</div>
        <div class="h3-content-style">
          <span class="symbol">¥</span>
          <span class="money"
                style="color: #e65c2e; marginleft: 4px">{{ordersItem.sumPrice}}</span>
        </div>
        <div class="price-details"
             @click="showPriceDetail">价格明细</div>
      </div>
    </div>

    <div class="believers-info"
         v-if="ordersItem?.pwItems?.length > 0">
      牌位信息
    </div>
    <van-cell-group v-if="ordersItem?.pwItems?.length > 0">
      <div class="cell">
        <span class="h3-title-style"
              style="color: rgb(0, 0, 0); font-weight: bold">方位</span>
        <span class="h3-content-style"
              style="font-weight: bold"></span>
      </div>

      <div class="pwItems_container"
           v-for="(item, index) in ordersItem?.pwItems"
           :key="index">
        <div class="pwItems_container"
             v-for="(pwItem, index) in item?.items"
             :key="index">
          <van-cell title="被超度人"
                    :value="pwItem"
                    style="padding: 1px 16px" />
        </div>
        <div class="pwItems_container"
             v-for="(jzs, index) in item?.jzs"
             :key="index">
          <van-cell title="祭主"
                    :value="jzs"
                    style="padding: 1px 16px" />
        </div>
      </div>
    </van-cell-group>
    <div class="believers-info"
         v-if="ordersItem?.memorialsStr?.length > 0"
         style="margin-top: 4px">
      待办服务
    </div>
    <div class="pwItems_container"
         v-for="(item, index) in ordersItem?.agencyItems"
         :key="index">
      <div class="goods-item"
           v-if="ordersItem?.memorialsStr?.length > 0">
        <div class="goods-image">
          <img :src="item?.photo"
               :alt="item?.name"
               style="width: 60px; height: 60px" />
        </div>
        <div class="center-wrap">
          <div class="goods-name">{{ item?.name }}</div>
        </div>
        <div class="right-wrap">
          <div class="goods-price">¥ {{ item?.price }}</div>
          <div class="goods-amount">x{{ item?.count }}</div>
        </div>
      </div>
    </div>

    <div class="believers-info"
         style="margin-top: 4px; margin-bottom: 4px">
      信众信息
    </div>
    <van-cell-group>
      <!-- <div class="cell">
        <span
          class="h3-title-style"
          style="color: rgb(0, 0, 0); font-weight: bold"
          >序号</span
        >
        <span class="h3-content-style" style="font-weight: bold"></span>
      </div> -->
      <div class="believer-info">
        <div style="display: flex; color: rgba(0, 0, 0, 0.6); width: 80px">
          功德主
        </div>
        <div class="person-info">
          <div class="h3-content-style">{{ ordersItem?.user?.name }}</div>
          <div class="h3-content-style">{{ ordersItem?.user?.phoneExt }}</div>
          <div class="h3-content-style">{{ ordersItem?.user?.birthday }}</div>
          <div class="h3-content-style">
            {{ordersItem?.user?.times}}
          </div>

          <div class="h3-content-style">{{ordersItem?.user?.age}}</div>
          <div class="h3-content-style">{{ordersItem?.user?.sex}}</div>
          <div class="h3-content-style">
            {{ordersItem?.user?.province}} {{ordersItem?.user?.city}}
            {{ordersItem?.user?.area}}{{ordersItem?.user?.address}}
          </div>
        </div>
      </div>
    </van-cell-group>

    <div class="believers-info"
         style="margin-top: 4px; margin-bottom: 4px">
      订单信息
    </div>
    <van-cell-group>
      <div style="
          display: flex;
          height: 40px;
          align-items: center;
          padding: 0 16px;
          font-size: 14px;
        ">
        <div style="display: flex; color: rgba(0, 0, 0, 0.6); width: 100%">
          订单编号
        </div>
        <div style="
            display: flex;
            color: rgba(0, 0, 0, 0.6);
            flex: 1;
            justify-content: flex-end;
          ">
          {{ordersItem?.orderNo}}
        </div>
      </div>
      <div style="display: flex; height: 1px; color: #444; width: 100%" />
      <div style="
          display: flex;
          height: 40px;
          align-items: center;
          padding: 0px 16px;
          font-size: 14px;
        ">
        <div style="display: flex; color: rgba(0, 0, 0, 0.6); width: 100px">
          下单时间
        </div>
        <div style="
            display: flex;
            color: rgba(0, 0, 0, 0.6);
            flex: 1;
            justify-content: flex-end;
          ">
          {{ordersItem?.createTime}}
        </div>
      </div>
      <!-- <van-cell
        class="custom-cell"
        title="订单编号"
        :value="ordersItem?.orderNo"
      />
      <van-cell
        class="custom-cell"
        title="下单时间"
        :value="ordersItem?.createTime"
      /> -->
    </van-cell-group>
    <!-- <div class="xiadan-btn" v-if="ordersItem.status == 2">
      <van-button type="primary" @click="reorder">再次预定</van-button>
    </div> -->
    <div class="xiadan-btn">
      <!-- <van-button plain
                  type="info"
                  @click="deleteOrder"
                  v-if="ordersItem.status == 1"
                  style="margin-right: 10px">删除订单</van-button>
      <van-button plain
                  type="info"
                  @click="cancelOrder"
                  v-if="ordersItem.status == 0"
                  style="margin-right: 10px">取消订单</van-button> -->
      <van-button type="info"
                  @click="wxPayOrder"
                  v-if="detailStatus == 0"
                  style="margin-right: 10px">立即支付</van-button>
    </div>
    <van-action-sheet v-model="show"
                      title="价格明细"
                      style="height: 500px">
      <div style="
          display: flex;
          padding-left: 16px;
          font-size: 16px;
          font-weight: 600;
          color:red;
        ">
        付款金额&nbsp;&nbsp;¥{{  ordersItem?.sumPrice}}
      </div>
      <div style="display: flex; height: 1px; background: #ccc; width: 100%;margin-top: 10px;"></div>
      <div style="display: flex; margin-top: 10px">
        <div style="
            display: flex;
            padding-left: 16px;
            font-size: 16px;
            font-weight: 600;
          ">
          法会活动
        </div>
        <div style="
            display: flex;
            padding-right: 16px;
            font-size: 14px;
            flex: 1;
            justify-content: flex-end;
          ">
          ¥{{ ordersItem?.price }}
        </div>
      </div>
      <div style="display: flex; margin-top: 10px">
        <div style="display: flex; padding-left: 16px; font-size: 14px">
          {{ ordersItem?.activityName }}
        </div>
        <div style="
            display: flex;
            padding-right: 16px;
            font-size: 14px;
            flex: 1;
            justify-content: flex-end;
          ">
          ¥{{ ordersItem?.price }} X 1
        </div>
      </div>
      <div style="display: flex; height: 1px; background: #ccc; width: 100%;margin-top: 10px;"></div>

      <!-- <div style="display: flex; margin-top: 10px; flex-direction: column">
        <div class="order_container"
             v-for="(order, index) in ordersItem?.priceInfo?.agencyPrices
            ?.agencyPrices"
             :key="index">
          <div style="display: flex; margin-top: 10px">
            <div style="
              display: flex;
              padding-left: 16px;
              font-size: 16px;
              font-weight: 600;
            ">
              代办服务
            </div>
            <div style="
              display: flex;
              padding-right: 16px;
              font-size: 14px;
              flex: 1;
              justify-content: flex-end;
            ">
              ¥{{ order.price }}
            </div>
          </div>
          <div style="display: flex; margin-top: 10px">
            <div style="display: flex; padding-left: 16px; font-size: 14px">
              {{ order?.name }}
            </div>
            <div style="
                display: flex;
                padding-right: 16px;
                font-size: 14px;
                flex: 1;
                justify-content: flex-end;
              ">
              ¥{{ order?.price }} X {{ order?.count }}
            </div>
          </div>
        </div>
      </div> -->
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: "QuanbuDingdanDetail",
  data() {
    return {
      show: false,
      ordersItems: [
        {
          activityType: "0",
          status: 0,
          activityName: "十一月初一消灾祈福仪式",
          price: 100,
          timeRange: "2024-12-01 08:30 至 2024-12-01 15:00",
        },
      ],
      ordersItem: JSON.parse(localStorage.getItem("orderInfo")),
      index: this.$route.params.orderInfo,
      orderStatus: "已取消",
      tipsInfo: "由于超时未支付，订单已自动取消，请重新预订",
      isOrderCancelled: true,
      ticketName: "十一月初一消灾祈福仪式",
      ticketDate: "2024-12-01 08:30 至 2024-12-01 15:00",
      paymentAmount: 100,
      believerName: "陶",
      believerPhone: "135****2091",
      believerBirthDate: "2012-03-14",
      believerLunarBirthDate: "壬辰年(2012)二月廿二 丑时(01:00-03:00)",
      believerAge: "13岁",
      believerGender: "男",
      believerAddress: "北京市 北京市 东城区 慧华苑",
      orderNumber: "D2411181120381162881",
      orderTime: "2024-11-18 11:20:38",
      detailStatus: "",
    };
  },
  methods: {
    deleteOrder() {
      console.log("删除订单");
      // 在此处添加删除订单的逻辑
      this.$http
        .get("/tempt/api/sjte/deleteOrder", {
          params: {
            type: 0,
            activityType: 1,
          },
        })
        .then((value) => {
          console.log(value, "value");
          debugger;
          this.ordersItems = value.result;
          this.ordersItem = this.ordersItems[0];
        });
    },
    cancelOrder() {
      console.log("取消订单");
      // 在此处添加删除订单的逻辑
      this.$http
        .get("/tempt/api/sjte/cancelOrder", {
          params: {
            orderId: this.ordersItem.id,
          },
        })
        .then((value) => {
          if (value.success) {
            // this.getOrderItem();
            this.$router.push("/QuBuDingDan");
          }
        });
    },
    cancelOrder() {
      console.log("删除订单");
      // 在此处添加删除订单的逻辑
      this.$http
        .get(" /tempt/api/sjte/deleteOrder", {
          params: {
            orderId: this.ordersItem.id,
          },
        })
        .then((value) => {
          console.log(value, "value");
          if (value.success) {
            // this.getOrderItem();
            this.$router.push("/QuBuDingDan");
          }
        });
    },

    findDetail(index) {
      this.$router.push({
        name: "QuanBuDingDanDetail",
        params: {
          id: this.index,
          type: 0,
          activityType: 1,
        },
      });
      // localStorage.setItem("zf_activity_type", this.type);
      // localStorage.setItem("zf_id", index);
    },
    getDetail() {
      // 在此处添加再次预订的逻辑
      this.$http
        .get("/tempt/api/sjte/getOrderDetail", {
          params: {
            orderId: this.ordersItem.id,
          },
        })
        .then((value) => {
          console.log(value, "value");
          if (value.success) {
            this.detailStatus = value.result?.status;
          }
        });
    },
    getDetailId(vm, id) {
      // 在此处添加再次预订的逻辑
      vm.$http
        .get("/tempt/api/sjte/getOrderDetail", {
          params: {
            orderId: id,
          },
        })
        .then((value) => {
          if (value.success) {
            vm.detailStatus = value.result?.status;
          }
        });
    },
    onBridgeReady(wxData) {
      var vm = this
      console.log("wxData", wxData);
      const { appId, timeStamp, nonceStr, packageInfo, signType, paySign } =
        wxData;
      console.log(
        "wxData",
        appId,
        timeStamp,
        nonceStr,
        packageInfo,
        signType,
        paySign
      );
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId,
          timeStamp: timeStamp,
          nonceStr: nonceStr,
          package: packageInfo,
          signType: signType,
          paySign: paySign,
        },
        function (res) {

          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            vm.$router.push({ name: "QuBuDingDan", params: { type: 0 } });
            vm.getDetailId(vm, vm.ordersItem.id);
          }
        }
      );
    },
    /**
     * 支付
     * @param {*} type
     */
    async wxPayOrder() {
      try {
        const data = await this.$http.get("/tempt/api/sjte/payOrder", {
          params: {
            orderId: this.ordersItem.id,
          },
        });
        if (data.success) {
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
            }
          } else {
            this.onBridgeReady(data.result);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // getOrderItem() {
    //         this.$http.post("/tempt/api/sjte/createOrder", data)
    //     .then((response) => {
    //       console.log('====================================');
    //       console.log(JSON.parse(response));
    //       console.log('====================================');
    //       if(response.success){
    //        this.ordersItem =response.result.orderInfo;
    //       }
    //     })
    // },
    showPriceDetail() {
      this.show = true;
    },
  },
  // 生命周期-创建完成（可以访问当前this实例）
  created() {
    // this.getOrderItem();
  },
};
</script>

<style scoped>
.outer-containers {
  width: 100%;
  padding-bottom: 75px;
}
.order-status-container {
  min-height: 129px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 16px;
}
.status-text {
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #fff;
}

.tips-info {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  margin-top: 4px;
}

.ticket-info {
  border-radius: 16px 16px 0 0;
  margin-top: -20px;
  background-color: #fff;
  padding: 16px;
  border-radius: 16px 16px 0 0;
}
.cell {
  background-color: #fff;
  padding: 4px 16px;
}
.flex-start {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.ticket-name {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 700;
  color: #000;
  margin-bottom: 8px;
}
.flex-start {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  display: flex;
  margin-top: 10px;
}
.h3-title-style {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;
}
.h3-content-style {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;
  margin-left: 10px;
  align-items: center;
}
.outer-container {
  padding: 16px;
}
.symbol {
  font-size: 14px;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
  font-weight: 700;
  color: #e65c2e;
}
.price-details {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #007aaa;
  margin-left: auto;
}
.money {
  font-size: 18px;
  font-weight: bold;
}
.bottom-fixed-button-wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}

.believer-info {
  padding: 10px;
  display: flex;
}
.believers-info {
  padding-left: 16px;
  font-weight: 600;
}
.custom-cell .van-cell__value {
  position: relative;
  overflow: hidden;
  color: #969799;
  vertical-align: middle;
  word-wrap: break-word;
}
.custom-cell .van-cell__title {
  width: 100px;
}
.van-cell__title,
.van-cell__value {
  /* -webkit-box-flex: 1; */
  /* -webkit-flex: 1; */
  /* flex: 1; */
}
.goods-item {
  margin: 12px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.img {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  margin-right: 16px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.center-wrap {
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
  margin-left: 4px;
}
.right-wrap {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  margin-left: 16px;
  text-align: right;
  margin-right: 16px;
}
.goods-price {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
}
.goods-amount {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.4);
  margin-top: 8px;
}
.goods-image {
  width: 64px;
  height: 64px;
  margin-left: 16px;
}
.xiadan-btn {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
  margin-top: 8px;
}
.van-divider {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin: 16px 0;
  color: #969799;
  font-size: 14px;
  line-height: 24px;
  border-color: #ebedf0;
  border-style: solid;
  border-width: 0;
  border-radius: 16px 16px 0 0;
  margin-top: -20px;
}
.mb-content {
  padding: 16px 16px 400px;
}
</style>
